import * as jsxRuntime from "/tmp/tmp_zY9LbsufHjhV/front/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment